import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.videoUrl
    ? _c(
        "div",
        {
          staticClass: "video-card video-card-vue d-inline-flex",
          attrs: { "data-qa-is-lpu": "" },
        },
        [
          _vm._t(
            "play-button",
            function () {
              return [
                _c(
                  "div",
                  {
                    directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                    staticClass:
                      "video-card__play-icon d-flex align-center cursor-pointer bg-gray-0",
                    class: { "video-card__play-icon--mobile": _setup.isMobile },
                    attrs: { "data-qa": "video_card_play_icon" },
                    on: { click: _setup.handleOpenDialog },
                  },
                  [
                    _c(VImg, {
                      attrs: {
                        alt: _setup.tStatic("Видеовизитка"),
                        width: _setup.isMobile ? 24 : 28,
                        height: _setup.isMobile ? 24 : 28,
                        src: "/static/_v1/pd/icons/ui-kit/video-card-play.svg",
                      },
                    }),
                    _vm._v(" "),
                    !_setup.isMobile
                      ? _c("div", { staticClass: "text--text text-body-2" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.tStatic("Видеовизитка")) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            {
              on: {
                click: _setup.handleOpenDialog,
              },
            }
          ),
          _vm._v(" "),
          _setup.isMobile
            ? _c(
                VDialog,
                {
                  attrs: {
                    "data-qa": "video_card_dialog",
                    fullscreen: "",
                    divider: "",
                  },
                  model: {
                    value: _setup.isDialogVisible,
                    callback: function ($$v) {
                      _setup.isDialogVisible = $$v
                    },
                    expression: "isDialogVisible",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "video-card-wrapper text",
                      attrs: { "data-qa": "video_card_dialog" },
                    },
                    [
                      _c("div", {
                        staticClass:
                          "video-card-player-close ui-icon_reset bg-gray-0--text ui-icon-close-not-a-circle",
                        on: {
                          click: function ($event) {
                            _setup.isDialogVisible = false
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "video-card-switch-state",
                        on: { click: _setup.videoSwitchState },
                      }),
                      _vm._v(" "),
                      !_setup.isVideoPlaying
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "video-card-play primary--text branding-btn branding-btn--primary-icon",
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "ui-icon_reset ui-icon-player-play",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.videoTimeTotal && _setup.videoTimeCurrent
                        ? _c("div", { staticClass: "video-card-time-cover" }, [
                            _c("div", { staticClass: "video-card-time" }, [
                              _c(
                                "div",
                                { staticClass: "text-body-1 bg-gray-0--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.videoTimeCurrent) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-body-1 bg-gray-60--text px-1",
                                },
                                [_vm._v("/")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-body-1 bg-gray-60--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.videoTimeTotal) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("video", {
                        ref: "videoRef",
                        staticClass: "video-card-player",
                        attrs: {
                          "data-qa": "video_card_video",
                          playsinline: "",
                          src: _vm.videoUrl,
                        },
                        on: {
                          timeupdate: _setup.handleTimeupdate,
                          loadedmetadata: _setup.handleLoadedmetadata,
                          ended: _setup.handleEnded,
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _c(
                _setup.CoreDialog,
                {
                  attrs: {
                    "data-qa": "video_card_dialog",
                    size: "lg",
                    title: _setup.tStatic("Видеовизитка"),
                    divider: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prependBtn",
                        fn: function ({ btnProps }) {
                          return [
                            _c(
                              VBtn,
                              _vm._b(
                                {
                                  on: {
                                    click: function ($event) {
                                      _setup.isDialogVisible = false
                                    },
                                  },
                                },
                                "v-btn",
                                btnProps,
                                false
                              ),
                              [
                                _c("span", {
                                  staticClass: "ui-icon-close-not-a-circle",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1322088010
                  ),
                  model: {
                    value: _setup.isDialogVisible,
                    callback: function ($$v) {
                      _setup.isDialogVisible = $$v
                    },
                    expression: "isDialogVisible",
                  },
                },
                [
                  _vm._v(" "),
                  _c("video", {
                    ref: "videoRef",
                    staticClass:
                      "video-card-player video-card-player--desktop h-100",
                    attrs: {
                      "data-qa": "video_card_video",
                      controls: "",
                      src: _vm.videoUrl,
                    },
                    on: { ended: _setup.handleEnded },
                  }),
                ]
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }